<template>
  <div>
    <view-options elementId="paginasAmarillas" />

    <!-- <div class="view-options">
      <a class="exportButton" id="downloadButton" @click="download">
        <font-awesome-icon icon="file-export" />EXPORT VIEW
      </a>
    </div> -->

    <div class="product-view" id="paginasAmarillas">
      <div>
        <div class="lds-ellipsis" v-if="Product.length === 0">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <ad-goals
          v-bind:totalImpressions="Product.totalImpressions || 0"
          v-bind:totalClicks="Product.totalClicks || 0"
          :wording="wordings"
        ></ad-goals>
        <impressions
          :totalImpressions="Product.totalImpressions || 0"
          :yaxis="yaxis"
          :impressions="Product.impressions || []"
        ></impressions>
      </div>

      <product-look :productLook="productView"></product-look>

      <digital-presence
        v-if="digitalPresence.length && businessUnitId != 3"
        :digitalPresence="digitalPresence"
        :totalDigitalPresent="totalDigitalPresent"
        :totalGoogle="totalGoogle"
        :googleResults="googleResults"
      ></digital-presence>

      <ad-interactions
        v-if="adInteractions.length"
        :adInteractions="adInteractions"
      ></ad-interactions>

      <div class="widget ad-views" v-if="showAdsWidget">
        <h3 class="widget-title">
          Este es el desempeño de tus anuncios en
          {{ $route.params.productName }}
        </h3>

        <!-- <div class="cards-wrapper" v-if="isAxesa">
          <ad-listings
            :adListings="adListings"
            v-if="adListings.length > 0"
          ></ad-listings>
          <ad-banners
            :adsBanners="adsBanners"
            v-if="adsBanners.length > 0"
          ></ad-banners>
        </div> -->

        <div>
          <AdListingsYP
            :adListings="adListings"
            v-if="adListings.length > 0"
          ></AdListingsYP>

          <ad-banners
            :adsBanners="adsBanners"
            v-if="adsBanners.length > 0"
          ></ad-banners>
        </div>
      </div>
    </div>

    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import AdGoals from "@/components/Widgets/AdGoals.vue";
import ProductLook from "@/components/Widgets/ProductLook.vue";
import Impressions from "@/components/Widgets/Impressions.vue";
import DigitalPresence from "@/components/Widgets/DigitalPresence.vue";
import AdInteractions from "@/components/Widgets/AdInteractions.vue";
import AdListingsYP from "@/components/Widgets/YourAds/AdListingsYP.vue";
import AdBanners from "@/components/Widgets/YourAds/AdBanners.vue";

// REQUEST
import { mapState, mapGetters } from "vuex";
import { ProductService } from "../../services/product.service";
import { GoogleSearchService } from "../../services/googlesearch.service";
import { PortalStatsService } from "../../services/portal-stats.service";
import { SubscriberService } from "../../services/subscriber.service";
import GoogelAnalytics from "../../services/google-analytics.service";
import html2canvas from "html2canvas";
import { validateProductExpirationDate } from '../../util';
import { BUSINESS_UNIT_ID } from "../../constants";
// import { mapState } from "vuex";
export default {
  name: "paginas-amarillas",
  components: {
    ViewOptions,
    AdGoals,
    ProductLook,
    Impressions,
    DigitalPresence,
    AdInteractions,
    AdListingsYP,
    AdBanners
  },
  data() {
    return {
      isAxesa: 0,
      wordings: {
        Impressions:
          "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
        Clicks: "Interacciones con la audiencia"
      },
      Product: [],
      totalDigitalPresent: {},
      totalGoogle: {},
      yaxis: {
        labels: {
          maxWidth: 80
        }
      },
      productData: {
        totalImpressions: 683575,
        totalClicks: 5263
      },
      productView: {
        totalProductData: 0,
        sessions: 0,
        mobilePercentage: 0,
        desktopPercentage: 0
      },
      businessUnitId: 1,
      digitalPresence: [],
      googleResults: [],
      adListings: [],
      adInteractions: [],
      adsBanners: []
    };
  },
  computed: {
    showAdsWidget() {
      return this.adListings.length > 0 || this.adsBanners.length > 0;
    },

    ...mapGetters(["date1", "date2", "clientComercialNameStore"])
  },
  methods: {
    ...mapState(["currentBusiness"]),
    download: function() {
      let getCanvas;
      html2canvas(document.getElementById("paginasAmarillas")).then(function(
        canvas
      ) {
        document.getElementById("export").appendChild(canvas);
        getCanvas = canvas;

        var imgageData = getCanvas.toDataURL("image/png");
        var newData = imgageData.replace(
          /^data:image\/png/,
          "data:application/octet-stream"
        );
        let el = document.getElementById("downloadButton");
        el.download = "CaribeMetricsExport.png";
        el.href = newData;
      });
    },
    transformSearchConsoleStatsToProducts: function(searchConsoleStats) {
      let result = [];
      searchConsoleStats.reduce(function(collector, currentValue) {
        let currentDate = new Date(currentValue.startDate);

        let firstDateOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );

        if (!collector[firstDateOfMonth] && !isNaN(currentValue.impressions)) {
          collector[firstDateOfMonth] = {
            date: firstDateOfMonth,
            count: 0
          };
          result.push(collector[firstDateOfMonth]);
        }

        if (currentValue.impressions && !isNaN(currentValue.impressions)) {
          collector[firstDateOfMonth].count += parseInt(
            currentValue.impressions
          );
        }

        return collector;
      }, {});

      return result;
    },
    summaryProductImpressions: function(productImpressions) {
      let result = [];

      productImpressions.reduce(function(collector, currentValue) {
        let currentDate = new Date(currentValue.date);

        let firstDateOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );

        if (!collector[firstDateOfMonth] && !isNaN(currentValue.count)) {
          collector[firstDateOfMonth] = {
            date: firstDateOfMonth,
            count: 0
          };
          result.push(collector[firstDateOfMonth]);
        }

        if (currentValue.count && !isNaN(currentValue.count)) {
          collector[firstDateOfMonth].count += parseInt(currentValue.count);
        } else {
          console.log(`**${currentValue}`);
        }

        return collector;
      }, {});

      return result;
    }
  },
  watch: {
    date1: async function() {
      const { productId, subscriberId, businessUnitId } = this.$route.params;
      const { customerId } = this.$route.query;
      this.businessUnitId = businessUnitId;
      const products = this.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products,productId,this.$store.state.subscriber.date1);

      let fromDate = this.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : this.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      const currentSubscriberId = this.$route.params.subscriberId;
      const bookCode = "SPPG";
      const commercialName = this.clientComercialNameStore;

      const product = new ProductService(this).getProductGeneralStats(
        productId,
        businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
        toDate,
        fromDate,
        businessUnitId,
        bookCode,
        commercialName
      );
      const category = new ProductService(this).getCategoryStats(
        businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
        productId,
        toDate,
        fromDate
      );

      const googleResults = new GoogleSearchService(
        this
      ).GetGoogleCategoryStats({
        productId,
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        bookCode,
        commercialName
      });
      const itemsStats = new PortalStatsService(this).GetItemsStats({
        subscriberId: businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
        productId,
        fromDate,
        toDate
      });
      const adsBanners = new SubscriberService(this).getBanners({
        productId,
        subscriberId,
        businessUnitId
      });

      const subscriberListing = new SubscriberService(
        this
      ).getSubscriberListing(
        "SPPG",
        parseInt(currentSubscriberId),
        businessUnitId
      );

      const endDate = new Date();

      let startDate = new Date();

      startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));

      const GoogelAnalyticsService = new GoogelAnalytics(this);

      const googleAnalytics = GoogelAnalyticsService.getAnalytics(
        "SPPG",
        businessUnitId,
        startDate,
        endDate
      );

      const googleAnalyticsSearchs = GoogelAnalyticsService.getSearchs("SPPG");

      Promise.all([
        googleAnalyticsSearchs,
        subscriberListing,
        category,
        googleAnalytics,
        product,
        googleResults,
        itemsStats,
        adsBanners
      ]).then(responses => {
        this.productView.sessions = Number(responses[3].sessions);
        this.productView.mobilePercentage = Number(
          responses[3].devicesPercentages.mobile
        );
        this.productView.desktopPercentage = Number(
          responses[3].devicesPercentages.desktop
        );
        this.adListings = responses[1];
        this.digitalPresence = responses[2];
        this.productView.totalProductData = responses[3].pageViews;
        this.Product = responses[4];
        this.googleResults = responses[5].sort((value1,value2)=> value2.impressions - value1.impressions);
        this.adInteractions = responses[6];
        this.adsBanners = responses[7];

        if (responses[4] != undefined && responses[4] != "") {
          let productSummary = this.summaryProductImpressions(
            this.Product.impressions
          );

          this.Product.impressions = productSummary;
        }

        let totalClicks = 0;
        let totalImpressions = 0;

        let totalClicksSum = 0;
        let totalImpressionsSum = 0;

        (responses[2].slice(0, 5) || []).forEach(response => {
          totalImpressions += parseInt(response.impressions);
          totalClicks += parseInt(response.clicks);
        });

        (responses[2].slice(5, 50) || []).forEach(response => {
          totalImpressionsSum += parseInt(response.impressions);
          totalClicksSum += parseInt(response.clicks);
        });

        let googleClickT = 0;
        let googleImpressionsT = 0;

        this.googleResults.forEach(resp => {
          googleClickT += parseInt(resp.clicks);
          googleImpressionsT += parseInt(resp.impressions);
        });

        let clickT = totalClicksSum + totalClicks;
        let impreT = totalImpressionsSum + totalImpressions;

        function commaSeparateNumber(amount, decimals = 0) {
          amount += ""; // por si pasan un numero en vez de un string
          amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

          decimals = decimals || 0; // por si la variable no fue fue pasada

          // si no es un numero o es igual a cero retorno el mismo cero
          if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

          // si es mayor o menor que cero retorno el valor formateado como numero
          amount = "" + amount.toFixed(decimals);

          var amount_parts = amount.split("."),
            regexp = /(\d+)(\d{3})/;

          while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(
              regexp,
              "$1" + "," + "$2"
            );

          return amount_parts.join(".");
        }

        const clickT1 = commaSeparateNumber(clickT);
        const impreT1 = commaSeparateNumber(impreT);

        const googleClickT1 = commaSeparateNumber(googleClickT);
        const googleImpressionsT1 = commaSeparateNumber(googleImpressionsT);

        this.totalGoogle = { googleClickT1, googleImpressionsT1 };
        this.totalDigitalPresent = { clickT1, impreT1 };
      });
    },
    date2: async function() {
      const { productId, subscriberId, businessUnitId } = this.$route.params;
      this.businessUnitId = businessUnitId;
      const { customerId } = this.$route.query;
      const products = this.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products, productId, this.$store.state.subscriber.date1)

      let fromDate = this.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : this.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;
      const currentSubscriberId = this.$route.params.subscriberId;
      const bookCode = "SPPG";
      const commercialName = this.clientComercialNameStore;
      const product = new ProductService(this).getProductGeneralStats(
        productId,
        businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
        toDate,
        fromDate,
        businessUnitId,
        bookCode,
        commercialName
      );
      const category = new ProductService(this).getCategoryStats(
        businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
        productId,
        toDate,
        fromDate
      );

      const googleResults = new GoogleSearchService(
        this
      ).GetGoogleCategoryStats({
        productId,
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        bookCode,
        commercialName
      });
      const itemsStats = new PortalStatsService(this).GetItemsStats({
        subscriberId: businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
        productId,
        fromDate,
        toDate
      });
      const adsBanners = new SubscriberService(this).getBanners({
        productId,
        subscriberId,
        businessUnitId
      });

      const subscriberListing = new SubscriberService(
        this
      ).getSubscriberListing(
        "SPPG",
        parseInt(currentSubscriberId),
        businessUnitId
      );

      const endDate = new Date();

      let startDate = new Date();

      startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));

      const GoogelAnalyticsService = new GoogelAnalytics(this);
      const googleAnalytics = GoogelAnalyticsService.getAnalytics(
        "SPPG",
        businessUnitId,
        startDate,
        endDate
      );

      const googleAnalyticsSearchs = GoogelAnalyticsService.getSearchs("SPPG");

      Promise.all([
        googleAnalyticsSearchs,
        subscriberListing,
        category,
        googleAnalytics,
        product,
        googleResults,
        itemsStats,
        adsBanners
      ]).then(responses => {
        this.productView.sessions = Number(responses[3].sessions);
        this.productView.mobilePercentage = Number(
          responses[3].devicesPercentages.mobile
        );
        this.productView.desktopPercentage = Number(
          responses[3].devicesPercentages.desktop
        );

        this.adListings = responses[1];
        this.digitalPresence = responses[2];
        this.productView.totalProductData = responses[3].pageViews;
        this.Product = responses[4];
        this.googleResults = responses[5].sort((value1,value2)=> value2.impressions - value1.impressions);
        this.adInteractions = responses[6];
        this.adsBanners = responses[7];

        if (responses[4] != undefined && responses[4] != "") {
          let productSummary = this.summaryProductImpressions(
            this.Product.impressions
          );

          this.Product.impressions = productSummary;
        }

        //calculo digPresent

        let totalClicks = 0;
        let totalImpressions = 0;

        let totalClicksSum = 0;
        let totalImpressionsSum = 0;
        (responses[2].slice(0, 5) || []).forEach(response => {
          totalImpressions += parseInt(response.impressions);
          totalClicks += parseInt(response.clicks);
        });

        (responses[2].slice(5, 50) || []).forEach(response => {
          totalImpressionsSum += parseInt(response.impressions);
          totalClicksSum += parseInt(response.clicks);
        });

        let googleClickT = 0;
        let googleImpressionsT = 0;

        this.googleResults.forEach(resp => {
          googleClickT += parseInt(resp.clicks);
          googleImpressionsT += parseInt(resp.impressions);
        });

        let clickT = totalClicksSum + totalClicks;
        let impreT = totalImpressionsSum + totalImpressions;

        function commaSeparateNumber(amount, decimals = 0) {
          amount += ""; // por si pasan un numero en vez de un string
          amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

          decimals = decimals || 0; // por si la variable no fue fue pasada

          // si no es un numero o es igual a cero retorno el mismo cero
          if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

          // si es mayor o menor que cero retorno el valor formateado como numero
          amount = "" + amount.toFixed(decimals);

          var amount_parts = amount.split("."),
            regexp = /(\d+)(\d{3})/;

          while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(
              regexp,
              "$1" + "," + "$2"
            );

          return amount_parts.join(".");
        }

        const clickT1 = commaSeparateNumber(clickT);
        const impreT1 = commaSeparateNumber(impreT);

        const googleClickT1 = commaSeparateNumber(googleClickT);
        const googleImpressionsT1 = commaSeparateNumber(googleImpressionsT);

        this.totalGoogle = { googleClickT1, googleImpressionsT1 };
        this.totalDigitalPresent = { clickT1, impreT1 };
      });
    }
  },

  created: async function() {
    this.isAxesa = parseInt(localStorage.getItem("isAxesa") || 0);

    const { productId, subscriberId, businessUnitId } = this.$route.params;
    this.businessUnitId = businessUnitId;
    const { customerId } = this.$route.query;
    const products = this.$store.state.subscriber.products;
    const validatedFinalDate = validateProductExpirationDate(products,productId,this.$store.state.subscriber.date1);
    let fromDate = this.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : this.$store.state.subscriber.date2;
    let toDate = validatedFinalDate;
    const currentSubscriberId = this.$route.params.subscriberId;
    const bookCode = "SPPG";
    const commercialName = this.clientComercialNameStore;
    const product = new ProductService(this).getProductGeneralStats(
      productId,
      businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
      toDate,
      fromDate,
      businessUnitId,
      bookCode,
      commercialName
    );
    const category = new ProductService(this).getCategoryStats(
      businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
      productId,
      toDate,
      fromDate
    );

    const googleResults = new GoogleSearchService(this).GetGoogleCategoryStats({
      productId,
      subscriberId,
      businessUnitId,
      toDate,
      fromDate,
      bookCode,
      commercialName
    });

    const itemsStats = new PortalStatsService(this).GetItemsStats({
      subscriberId: businessUnitId == BUSINESS_UNIT_ID.IP ? customerId : subscriberId,
      productId,
      fromDate,
      toDate
    });
    const adsBanners = new SubscriberService(this).getBanners({
      productId,
      subscriberId,
      businessUnitId
    });

    const isMobile = screen.width <= 991 ? true : false;

    const subscriberListing = new SubscriberService(this).getSubscriberListing(
      "SPPG",
      parseInt(currentSubscriberId),
      businessUnitId,
      isMobile
    );

    const endDate = new Date();

    let startDate = new Date();

    startDate = new Date(startDate.setMonth(startDate.getMonth() - 12));

    const GoogelAnalyticsService = new GoogelAnalytics(this);

    const googleAnalytics = GoogelAnalyticsService.getAnalytics(
      "SPPG",
      businessUnitId,
      startDate,
      endDate
    );

    const googleAnalyticsSearchs = GoogelAnalyticsService.getSearchs("SPPG");

    Promise.all([
      googleAnalyticsSearchs,
      subscriberListing,
      category,
      googleAnalytics,
      product,
      googleResults,
      itemsStats,
      adsBanners
    ]).then(responses => {
      if (responses[3]) {
        this.productView.sessions = Number(responses[3].sessions);

        this.productView.mobilePercentage = Number(
          responses[3].devicesPercentages.mobile
        );

        this.productView.desktopPercentage = Number(
          responses[3].devicesPercentages.desktop
        );

        this.productView.totalProductData = responses[3].pageViews;
      }

      this.adListings = responses[1];

      this.digitalPresence = responses[2];

      this.Product = responses[4];

      if (responses[5] != undefined) this.googleResults = responses[5].sort((value1,value2)=> value2.impressions - value1.impressions);

      this.adInteractions = responses[6];
      this.adsBanners = responses[7];

      if (responses[4] != undefined && responses[4] != "") {
        let productSummary = this.summaryProductImpressions(
          this.Product.impressions
        );

        this.Product.impressions = productSummary;
      }

      // let productSummary = this.summaryProductImpressions(
      //   this.Product.impressions
      // );

      // this.Product.impressions = productSummary;

      //calculo digPresent

      let totalClicks = 0;
      let totalImpressions = 0;

      let totalClicksSum = 0;
      let totalImpressionsSum = 0;

      (responses[2].slice(0, 5) || []).forEach(response => {
        totalImpressions += parseInt(response.impressions);
        totalClicks += parseInt(response.clicks);
      });

      (responses[2].slice(5, 50) || []).forEach(response => {
        totalImpressionsSum += parseInt(response.impressions);
        totalClicksSum += parseInt(response.clicks);
      });

      let googleClickT = 0;
      let googleImpressionsT = 0;

      responses[5].forEach(response => {
        googleClickT += parseInt(response.clicks);
        googleImpressionsT += parseInt(response.impressions);
      });

      let clickT = totalClicksSum + totalClicks;
      let impreT = totalImpressionsSum + totalImpressions;

      function commaSeparateNumber(amount, decimals = 0) {
        amount += ""; // por si pasan un numero en vez de un string
        amount = parseFloat(amount.replace(/[^0-9.]/g, "")); // elimino cualquier cosa que no sea numero o punto

        decimals = decimals || 0; // por si la variable no fue fue pasada

        // si no es un numero o es igual a cero retorno el mismo cero
        if (isNaN(amount) || amount === 0)
          return parseFloat(0).toFixed(decimals);

        // si es mayor o menor que cero retorno el valor formateado como numero
        amount = "" + amount.toFixed(decimals);

        var amount_parts = amount.split("."),
          regexp = /(\d+)(\d{3})/;

        while (regexp.test(amount_parts[0]))
          amount_parts[0] = amount_parts[0].replace(regexp, "$1" + "," + "$2");

        return amount_parts.join(".");
      }

      const clickT1 = commaSeparateNumber(clickT);
      const impreT1 = commaSeparateNumber(impreT);
      const googleClickT1 = commaSeparateNumber(googleClickT);
      const googleImpressionsT1 = commaSeparateNumber(googleImpressionsT);

      this.totalGoogle = { googleClickT1, googleImpressionsT1 };
      this.totalDigitalPresent = { clickT1, impreT1 };
    });

    function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    topFunction();
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
@include respond-above(md) {
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.digital-presence,
      &.google-results,
      &.ad-interactions {
        grid-column: 1 / -1;
      }
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 30px;
      }
    }
  }
}

// loading
.exportButton {
  margin-bottom: 45px;
  margin-top: 45px;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

// view options

.view-options {
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  margin-top: -20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: -20px;
  margin-right: -20px;
  padding: 8px 20px;
  background-color: $white;
  border-bottom: $separator;
  .el-date-editor {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  .nav-export {
    display: none;
  }
}

@include respond-above(md) {
  .view-options {
    margin-top: -40px;
    justify-content: flex-end;
    background-color: transparent;
    padding: 0px;
    margin: 0 auto;
    border-bottom: 0;
    margin-bottom: 0px;
    margin-top: -45px;
    .el-date-editor {
      display: none;
    }
    .nav-export {
      display: flex;
    }
  }
}
</style>
